var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenWithCycle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9803 13.7739C15.8822 13.3634 15.4426 13.1035 15.0028 13.1957L13.7184 13.4607L11.8998 9.19144C11.7761 8.90081 11.474 8.71016 11.1379 8.71016H5.65764L5.48247 6.94305H9.66288C10.1155 6.94305 10.4823 6.60216 10.4823 6.1816C10.4823 5.76105 10.1154 5.42015 9.66288 5.42015H5.3316L5.13554 3.44201C5.92515 3.23159 6.50364 2.55703 6.50364 1.75566C6.50371 0.786035 5.65784 0 4.61447 0C3.57111 0 2.72524 0.786035 2.72524 1.7556C2.72524 2.3208 3.01383 2.82229 3.46031 3.14335L4.0944 9.54153C4.1331 9.93324 4.48684 10.2331 4.91027 10.2331H10.5809L12.4518 14.6251C12.5776 14.9205 12.8834 15.1064 13.2135 15.1064C13.2723 15.1064 13.3319 15.1004 13.3914 15.0883L15.3581 14.6822C15.8 14.5909 16.0784 14.1843 15.9803 13.7738V13.7739Z",
    fill: "#888888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11497 14.9761C3.6384 14.9761 1.62345 13.0825 1.62345 10.7546C1.62345 9.55992 2.1565 8.482 3.00786 7.71327L2.83641 5.91113C1.1342 6.93271 0 8.71967 0 10.7546C0 13.9238 2.74312 16.502 6.11497 16.502C8.15814 16.502 9.96583 15.5519 11.0769 14.1008L10.329 12.2017C9.69863 13.8177 8.05026 14.9761 6.11497 14.9761Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenWithCycle);
export default __webpack_public_path__ + "static/media/men-with-cycle.f12b24068e3b80f8ab62232d34dbdf21.svg";
export { ForwardRef as ReactComponent };